<template>
  <el-form :model="data" :rules="rules" ref="customeLimitFormRef" class="system-custome-num-form-con">
    <h1 class="sec-title">客户上限设置</h1>
    <template v-if="pageLoading">
      <div class="page-loading-group">
        <i class="el-icon-loading"></i>
        <p class="load-text">正在加载中，请稍后...</p>
      </div>
    </template>
    <template v-else>
      <div class="clearfix rule-con mt20">
        <p class="desc floatL"><b>客户拥有上限</b>：</p>
        <div class="desc floatL">
          <el-radio-group v-model="data.customer_max_num_checked_status">
            <el-radio :label="0">
              <span class="checkbox-label">禁用</span>
            </el-radio>
            <el-radio :label="1">
              <span class="checkbox-label">启用</span>
            </el-radio>
          </el-radio-group>
          <el-popover placement="top-start" trigger="hover" width="300">
            <div class="popover-info">
              <p>超过该数量，经纪人新增客户无法成功（已成交客户不计入）；如果在设置最大客户数前，员工所拥有客户数已超过上限，则原有客户不受影响，但无法再继续新增。</p>
            </div>
            <i class="iconfont popover-info-icon" slot="reference">&#xe7e2;</i>
          </el-popover>
        </div>
      </div>
      <!-- 开启上限限制 -->
      <div class="rule-group-back mt20" v-if="data.customer_max_num_checked_status == 1">
        <div class="clearfix rule-con">
          <div class="floatL desc lingqu-reusult">
            每个经纪人（特殊经纪人除外）拥有最大客户数
            <el-form-item prop="customer_max_num" class="mb0 inline-block">
              <el-input v-model.number="data.customer_max_num" size="mini" clearable />
            </el-form-item>
          </div>
        </div>
        <div class="specitial-con" v-for="(item, index) in data.special_customer_max_num_setting" :key="`custome_num_sepcial_${index}`">
          <span class="label">特殊经纪人</span>
          <el-form-item :prop="`special_customer_max_num_setting[${index}].admin_list`" :rules="rules.admin_list" class="mb0 flex-all">
            <div class="spe-flex">
              <span class="items" v-for="(user, i) in item.admin_list" :key="`custome_num_sepcial_user_${user.id}`">
                {{user.name}}
                <i class="iconfont iconguanbi" @click="removeUser(index, i)"></i>
              </span>
            </div>
          </el-form-item>
          <a class="increase" @click="addUser(item.admin_list, index)">添加人员</a>
          <div class="max-num">
            拥有最大客户数
            <el-form-item :prop="`special_customer_max_num_setting[${index}].num`" :rules="rules.customer_max_num" class="mb0 inline-block">
              <el-input  v-model.number="item.num" size="mini" clearable/>
            </el-form-item>
          </div>
          <a class="remove" @click="removeSpecial(index)">
            <i class="iconfont">&#xe673;</i>删除
          </a>
        </div>
        <el-button class="mt15 global-btn primary add-special-btn" icon="el-icon-plus" @click="addSpecial" v-if="data.special_customer_max_num_setting.length < 10">特殊经纪人</el-button>
      </div>
      <div class="mt20" v-if="showSave">
        <p class="saveTips">保存更改后即时生效，请谨慎操作哦！</p>
        <el-button size="small" class="save-btn global-btn primary" @click="handleValidate">保存</el-button>
      </div>
    </template>
    <!-- 选择特殊经纪人 -->
    <select-company-member ref="customeCountRef" @confirm="handleConfirmRob"/>
  </el-form>
</template>
<script>
import {getSystemCustomeLimit, setSystemCustomeLimit} from '@/api/system';
import {validateUser, validateChecked} from '../validateProp';
import SelectCompanyMember from '../../components/selectCompanyMember';
export default{
  name: 'CustomeNumSet',
  components: {SelectCompanyMember},
  watch:{
      data: {
          handler (newVal, oldVal){
              this.showSave = JSON.stringify(newVal) !== JSON.stringify(this.sourceData);
          },
          deep: true
      }
  },
  data () {
    return {
      pageLoading: true,
      data: {
        customer_max_num_checked_status: 0,
        customer_max_num: '',
        special_customer_max_num_setting: []
      },
      rules: {
        customer_max_num: [
          {validator: validateUser, trigger: 'blur'}
        ],
        admin_list: [
          {validator: validateChecked, trigger: 'change', name: '特殊经纪人'}
        ]
      },
      showSave: false,
      sourceData: {}
    }
  },
  created() {
    this.initLimit();
  },
  methods: {
    async initLimit () {
      this.pageLoading = true;
      try {
        const res = await getSystemCustomeLimit();
        this.data = {
          ...res,
          customer_max_num_checked_status: Number(res.customer_max_num_checked_status || 0),
          special_customer_max_num_setting: res.special_customer_max_num_setting || []
        }
        this.sourceData = JSON.parse(JSON.stringify(this.data));
      } catch (error) {
        this.$message.error(error.msg || '操作错误，请重试');
      } finally {
        this.pageLoading = false;
      }
    },
    removeUser (index, uIndex) {
      this.data.special_customer_max_num_setting[index].admin_list.splice(uIndex, 1);
    },
    addUser (data, key) {
      this.special_key = key;
      if (this.$refs.customeCountRef) {
        this.$refs.customeCountRef.open([...data], 1);
      }
    },
    handleConfirmRob (list) {
      this.$set(this.data.special_customer_max_num_setting[this.special_key], 'admin_list', list);
    },
    removeSpecial (index) {
      this.$confirm('确认删除该项设置？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(_ => {
        this.data.special_customer_max_num_setting.splice(index, 1);
      }).catch(e => {})
    },
    addSpecial () {
      this.data.special_customer_max_num_setting.push({
        num: '',
        admin_list: []
      })
    },
    handleValidate () {
      return new Promise(resolve => {
        this.$refs.customeLimitFormRef.validate(async valid => {
          if (!valid) return null;
          const data = {
            customer_max_num_checked_status: this.data.customer_max_num_checked_status
          }
          // 拼接特殊经纪人数据
          if (data.customer_max_num_checked_status == 1) {
            data.customer_max_num = this.data.customer_max_num;
            const special = {};
            (this.data.special_customer_max_num_setting || []).map(v => {
              special[v.num] = v.admin_list.map(m => m.id).join(',');
            })
            data.special_customer_max_num_setting = JSON.stringify(special);
          }
          // 保存数据
          try {
            await setSystemCustomeLimit(data);
            this.$message.success('保存成功');
          } catch (error) {
            this.$message.error(error.msg || '操作错误，请重试');
          }
        })
      })
    }
  },
}
</script>
<style lang="less">
.system-custome-num-form-con{
  .el-form-item__error{
    min-width: 200px;
    margin-left: 10px;
    margin-top: 5px;
  }
}
</style>
<style lang="less" scoped>
  .saveTips{
    color: #999999;
    font-size: 12px;
    margin-bottom: 15px;
  }
</style>
